module.exports = __webpack_public_path__ + "static/media/no-pending-service.77d30f89.png";